import React from 'react';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
    const DABdefinition = () => {
        const botMessage = createChatBotMessage('Most Advanced PEP Data Asset focused machine learning and automation platform for large teams.');
    
        setState((prev) => ({
          ...prev,
          messages: [...prev.messages, botMessage],
        }));
      };
    
  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
           DABdefinition 
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;